export function LineDestination ({ destination })  {
  return <span className="line__destination">
    <span className="label">{ destination }</span>
  </span>
}

export default LineDestination;